import React from 'react'



const HomePage = (props) => {
 
    return (
    <div className="mainContainer">
      <div className='mx-auto grid grid-cols-4 gap-x-2'>
        <div className='col-start-2 col-span-2'>
          <div className="flex justify-center py-3">
            <h1 className='font-bold'>Home Page!</h1>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HomePage